import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import Footer from "../components/Footer";

const RefundPolicyPage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-100 py-6 px-6">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_centered-nav/artifacts/o3oyffod_0AB76696-D43D-4560-996B-0C817906B442.PNG" 
              alt="takeatrip NYC" 
              className="h-16 w-auto"
            />
          </Link>

          {/* Title */}
          <h1 className="text-3xl font-bold text-slate-800 text-center flex-1">
            Refund Policy
          </h1>

          {/* Events Banner */}
          <Link to="/events">
            <Button 
              className="px-6 py-3 text-lg font-semibold rounded-full"
              style={{
                background: 'linear-gradient(to right, #1d476a, rgb(51 65 85))',
                color: 'white',
                border: 'none'
              }}
            >
              Events
            </Button>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto py-12 px-6">
        <div className="prose prose-slate max-w-none">
          <div className="text-slate-700 leading-relaxed space-y-6">
            
            <p><strong>Effective Date:</strong> October 1, 2025</p>
            
            <p>This Refund Policy applies to all purchases made through Takeatrip NYC and governs the terms under which refunds may or may not be provided.</p>

            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">No Refund Policy</h2>
            <p>All purchases made through Takeatrip NYC are final and non-refundable, including but not limited to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Ticket purchases</li>
              <li>Deposits and service fees</li>
              <li>Trip packages and bookings</li>
              <li>Add-on services</li>
            </ul>

            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">Circumstances That Do Not Qualify for Refunds</h2>
            <p>We do not offer refunds for the following circumstances:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Participant cancellations for any reason</li>
              <li>Illness, injury, or personal emergencies</li>
              <li>Scheduling conflicts or work obligations</li>
              <li>Weather-related conditions or changes</li>
              <li>Missed transportation or late arrivals</li>
              <li>Dissatisfaction with services or accommodations</li>
              <li>Changes in personal circumstances</li>
            </ul>

            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">Trip Cancellations by Takeatrip NYC</h2>
            <p>Takeatrip NYC reserves the right to cancel a trip at any time due to low participation, safety concerns, or events beyond our reasonable control.</p>
            
            <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Force Majeure Events</h3>
            <p>Events that may affect the trip and are considered outside our control ("Force Majeure") include, but are not limited to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Severe weather (e.g., snowstorms, hurricanes, blizzards)</li>
              <li>Natural disasters (e.g., earthquakes, floods, wildfires)</li>
              <li>Transportation disruptions or closures</li>
              <li>Governmental actions, health restrictions, or travel bans</li>
              <li>Strikes, labor disputes, or civil unrest</li>
              <li>Acts of war, terrorism, or domestic disturbances</li>
              <li>Power outages or utility failures</li>
              <li>Any other event that significantly impacts the safety, logistics, or feasibility of operating the trip as planned</li>
            </ul>

            <p>These events do not constitute a breach of contract by Takeatrip NYC and do not entitle participants to a refund. In the event of a cancellation caused by any of the above circumstances, Takeatrip NYC is not obligated to provide a refund, rescheduled trip, or credit.</p>

            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">Payment Disputes and Chargebacks</h2>
            <p>Any fees incurred by us as a result of failed, reversed, or disputed payments (including but not limited to Stripe chargeback fees) will be the responsibility of the customer and may be added to the outstanding balance.</p>

            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">Travel Insurance Recommendation</h2>
            <p>All participants are strongly encouraged to have valid travel insurance that includes coverage for:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Winter sports and adventure activities</li>
              <li>Trip cancellations and interruptions</li>
              <li>Medical emergencies</li>
              <li>Lost or stolen property</li>
            </ul>
            
            <p>This is for your own protection during potentially high-risk activities such as skiing and snowboarding. Failure to obtain adequate travel insurance is at the participant's own risk. Takeatrip NYC is not responsible for any costs, losses, or damages incurred as a result of lack of insurance coverage.</p>

            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">Acknowledgment</h2>
            <p>By booking with us, you acknowledge and accept this no-refund policy, including in the event of cancellations resulting from Force Majeure or other unforeseen circumstances. We will make reasonable efforts to communicate changes promptly, but cannot guarantee specific accommodations, outcomes, or timelines.</p>

            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">Questions</h2>
            <p>If you have questions about this Refund Policy, please contact us at: <a href="mailto:info@takeatripnyc.com" className="text-blue-600 hover:text-blue-800">info@takeatripnyc.com</a></p>

            <p className="text-sm text-slate-500 mt-8">This Refund Policy is part of our Terms and Conditions and should be read in conjunction with our full Terms and Conditions document.</p>

          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default RefundPolicyPage;